import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-text-skeleton',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  styleUrl: './text-skeleton.scss',
  host: {
    'aria-hidden': 'true',
    '[style.width]': 'width()',
    '[style.height]': 'height()',
    '[class.circle]': 'circle()',
  },
})
export class TextSkeletonComponent {
  readonly width = input('100%');
  readonly height = input('1em');
  readonly circle = input(false, { transform: booleanAttribute });
}
